import { AccountSearchResponseItem } from "./accountSearchResponseItem";

export class AccountSearchResponse {
    constructor(items: Array<AccountSearchResponseItem>, recordCount: number) {
        this.items = items;
        this.recordCount = recordCount;
    }

    items: Array<AccountSearchResponseItem>;
    recordCount: number;
}
